module.exports = __webpack_public_path__ + "static/img/leidabg1.76946d16.png";